import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DarkModeBtn from '../components/DarkModeBtn';
import SidebarSteps from '../components/SidebarSteps';
// import useAuthRedirect from '../hooks/useAuthRedirect';
function SignUp5() {
   // useAuthRedirect();
   const [randomPositions, setRandomPositions] = useState([]);
   const [userInputs, setUserInputs] = useState({});
   const [errorMessage, setErrorMessage] = useState('');
   const [isLoading, setIsLoading] = useState(false);
   const [originalWords, setOriginalWords] = useState([]);
   const navigate = useNavigate();
   useEffect(() => {
      const storedPhrase = localStorage.getItem('mnemonicPhrase');
      if (!storedPhrase) {
         navigate('/sign-up-4');
         return;
      }
      // Store original words
      const words = storedPhrase.split(' ');
      setOriginalWords(words);
      // Generate 4 random positions (1-12)
      const positions = [];
      while (positions.length < 4) {
         const randomPos = Math.floor(Math.random() * 12) + 1;
         if (!positions.includes(randomPos)) {
            positions.push(randomPos);
         }
      }
      positions.sort((a, b) => a - b);
      setRandomPositions(positions);
      // Initialize empty inputs
      const inputs = {};
      positions.forEach(pos => {
         inputs[pos] = '';
      });
      setUserInputs(inputs);
   }, [navigate]);
   const handleInputChange = (position, value) => {
      setUserInputs(prev => ({
         ...prev,
         [position]: value.toLowerCase().trim()
      }));
   };
   const handleSubmit = async (e) => {
      e.preventDefault();
      setErrorMessage('');
      setIsLoading(true);
      try {
         // Get JWT from localStorage
         const jwt = localStorage.getItem('jwt');
         if (!jwt) {
            setErrorMessage('Authentication token not found. Please sign in again.');
            setIsLoading(false);
            return;
         }
         // Verify all fields are filled
         const missingInputs = randomPositions.filter(pos => !userInputs[pos] || userInputs[pos].trim() === '');
         if (missingInputs.length > 0) {
            setErrorMessage('Please complete all required words.');
            setIsLoading(false);
            return;
         }
         // Local validation to check if input words match original phrase
         let localValidationPassed = true;
         randomPositions.forEach(pos => {
            const adjustedIndex = pos - 1; // Only for local comparison, as JS arrays are zero-based
            if (adjustedIndex >= 0 && adjustedIndex < originalWords.length) {
               if (userInputs[pos].trim().toLowerCase() !== originalWords[adjustedIndex].toLowerCase()) {
                  localValidationPassed = false;
               }
            }
         });
         if (!localValidationPassed) {
            setErrorMessage('One or more words do not match your recovery phrase. Please verify and correct.');
            setIsLoading(false);
            return;
         }
         console.log('Local validation successful: input words match original phrase');
         // Prepare payload with base-1 indices (as expected by API)
         const wordsPayload = randomPositions.map(position => ({
            id: position, // API expects base-1 indices
            keyword: userInputs[position].toLowerCase().trim()
         }));
         console.log('Sending payload to API:', { words: wordsPayload });
         try {
            const response = await fetch('https://pt-api.digit-a.net/api/mnemonic-phrase/validate-mnemonic-words', {
               method: 'POST',
               headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${jwt}`
               },
               body: JSON.stringify({ words: wordsPayload })
            });
            const responseText = await response.text();
            console.log('API response:', response.status, responseText);
            let data;
            try {
               data = JSON.parse(responseText);
            } catch (e) {
               console.error('Error parsing JSON response:', e);
               setErrorMessage('Error in server response. Please try again.');
               return;
            }
            if (response.ok) {
               // Successful validation
               console.log('API validation successful');
               navigate('/dashboard'); // or the appropriate route after successful validation
            } else {
               // API indicated an error with the words
               setErrorMessage(data.message || 'Error validating mnemonic phrase. Please verify your words.');
            }
         } catch (fetchError) {
            console.error('Error in API request:', fetchError);
            setErrorMessage('Network error while validating phrase. Please try again.');
         }
      } catch (error) {
         console.error('General error:', error);
         setErrorMessage('Error processing request. Please try again.');
      } finally {
         setIsLoading(false);
      }
   };
   return (
      <div className="container" page-key="signup5">
         <div className="row">
            <div className="col-12 d-flex justify-content-between justify-content-lg-end mb-4 align-items-center ">
               <span className="mt-auto d-lg-none">
                  <img src={process.env.PUBLIC_URL + '/assets/img/logo_propert.svg'} data-lightmodeimg alt="ProperT" border="0" />
               </span>
               <DarkModeBtn />
            </div>
            <div className="col-12">
               <div className="d-flex flex-column align-items-center align-items-lg-start w-100 gap-2 mb-3">
                  <h1 className="d-lg-none">Sign Up</h1>
                  <SidebarSteps activeStep={3} />
               </div>
               <div className='ppt_signup_steps'>
                  <form className="ppt_form signIn" onSubmit={handleSubmit}>
                     <h3 className="ppt_form_title mb-2 text-center text-lg-start">Recovery phrase</h3>
                     <p className="smallMe mb-4 mb-lg-5">To confirm, please write the following positions of your recovery phrase.</p>
                     {errorMessage && (
                        <div className="alert alert-danger mb-4" role="alert">
                           {errorMessage}
                        </div>
                     )}
                     {randomPositions.map(position => (
                        <div key={position} className="ppt_input_style mb-4">
                           <div data-numreco={position}>
                              <label className="" hidden>Word {position}</label>
                              <input
                                 type="text"
                                 className="form-control"
                                 value={userInputs[position] || ''}
                                 onChange={(e) => handleInputChange(position, e.target.value)}
                                 placeholder={`Enter word ${position}`}
                                 required
                                 disabled={isLoading}
                                 autoComplete="off"
                              />
                           </div>
                        </div>
                     ))}
                     <div className="ppt_input_style">
                        <button
                           type="submit"
                           className="ppt_btn_primary"
                           disabled={isLoading}
                        >
                           {isLoading ? 'Validating...' : 'Continue'}
                        </button>
                     </div>
                  </form>
               </div>
            </div>
         </div>
      </div>
   );
}
export default SignUp5;